import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

export const VENDOR_MULTIPLE_DATEPICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => VendorMultipleDatepickerComponent),
  multi: true
};

@Component({
    selector: 'vendor-multiple-datepicker',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './vendor-multiple-datepicker.component.html',
    styleUrls: ['./vendor-multiple-datepicker.component.scss'],
    providers: [VENDOR_MULTIPLE_DATEPICKER_VALUE_ACCESSOR],
})
export class VendorMultipleDatepickerComponent implements OnInit, ControlValueAccessor {
    @Input() listingId: any;
    @Input() selectedDays: Array<any> = [];
    @Input() highlightDays: Array<any> = [];
    @Input() dayClick: any = '';
    @Input() dayHover: string = '';
    @Input() rightClick: any = '';
    @Input() monthChanged: any = '';
    @Input() fontAwesome: boolean = false;
    @Input() matIcons: boolean = false;
    @Input() monthClick: any = '';
    @Input() weekDaysOff: Array<number> = [];
    @Input() allDaysOff: string = '';
    @Input() daysAllowed: any = '';
    @Input() disableNavigation: boolean = false;
    @Input() disallowBackPastMonths: boolean = false;
    @Input() disallowGoFuturMonths: string = '';
    @Input() showDaysOfSurroundingMonths: boolean = false;
    @Input() cssDaysOfSurroundingMonths: any = 'picker-empty';
    @Input() fireEventsForDaysOfSurroundingMonths: string = '';
    @Input() disableDaysBefore: any;
    @Input() disableDaysAfter: any;
    @Input() changeYearPast: string = '';
    @Input() changeYearFuture: string = '';
    @Input() calenderType: string = 'pricing';
    @Input() disableTodayDate: boolean = false;
    @Input() sundayFirstDay: boolean = false;
    @Input() month: any = moment().startOf('day');
    @Input() projectScope: Array<any> = [];

    arrow: number = 0;
    monthAdjustment: any;
    days: Array<any> = [];
    daysOff: any = [];
    disableBackButton: any = false;
    disableNextButton: any = false;
    daysOfWeek: Array<any> = [];
    yearsForSelect: any = [];
    monthToDisplay: string = '';
    yearToDisplay: string = '';

    ngOnInit(): void {
        if (this.month === undefined) {
            this.month = moment().startOf('day');
        }

        this.generate();
        this.daysOfWeek = this.getDaysOfWeek();
        this.arrowSelected();
        this.weekDaysOff = this.weekDaysOff || [];
    }

    arrowSelected() {
        if (this.matIcons) {
            this.arrow = 1;
        } else if (this.fontAwesome) {
            this.arrow = 2;
        }
    }

    writeValue(value: any[]) {
        if (value !== undefined) {
            this.projectScope = value;
            if (value !== null) {
                this.projectScope = this.projectScope.map((val: Date) => {
                    return moment(val);
                });
                this.projectScope.forEach((val: Date) => {
                    let day = val;
                    this.days.forEach((d) => {
                        if (d.date.isSame(day)) {
                            d.mdp.selected = true;
                            return;
                        }
                    });
                });
            }
        }
    }

    propagateChange = (_: any) => { };

    registerOnChange(fn: any) {
        this.propagateChange = fn;
    }

    registerOnTouched() { }

    @Input() _projectScope: any[] = [];
    get projectScope2() {
        return this._projectScope;
    }
    set projectScope2(val) {
        this._projectScope = val;
        this.propagateChange(this._projectScope);
    }

    checkNavigationButtons() {
        let today = moment(),
            previousMonth = moment(this.month).subtract(1, 'month'),
            nextMonth = moment(this.month).add(1, 'month');
        this.disableBackButton = this.disableNavigation || (this.disallowBackPastMonths && today.isAfter(previousMonth, 'month'));
        this.disableNextButton = this.disableNavigation || (this.disallowGoFuturMonths && today.isBefore(nextMonth, 'month'));
    }

    getDaysOfWeek() {
        let momentDaysOfWeek = moment().localeData().weekdaysMin(),
            daysOfWeek = [];
        for (var i = 1; i < 7; i++) {
            daysOfWeek.push(momentDaysOfWeek[i]);
        }
        if (this.sundayFirstDay) {
            daysOfWeek.splice(0, 0, momentDaysOfWeek[0]);
        } else {
            daysOfWeek.push(momentDaysOfWeek[0]);
        }
        return daysOfWeek;
    }

    getMonthYearToDisplay() {
        let month = this.month.format('MMMM');
        return month.charAt(0).toUpperCase() + month.slice(1);
    }

    getYearsForSelect() {
        var now = moment(),
            changeYearPast = Math.max(0, parseInt(this.changeYearPast, 10) || 0),
            changeYearFuture = Math.max(0, parseInt(this.changeYearFuture, 10) || 0),
            min = moment(this.month).subtract(changeYearPast, 'year'),
            max = moment(this.month).add(changeYearFuture, 'year'),
            result = [];
        max.add(1, 'year');
        for (var m = moment(min); max.isAfter(m, 'year'); m.add(1, 'year')) {
            if ((!this.disallowBackPastMonths || (m.isAfter(now, 'year') || m.isSame(now, 'year'))) && (!this.disallowGoFuturMonths || (m.isBefore(now, 'year') || m.isSame(now, 'year')))) {
                result.push(m.format('YYYY'));
            }
        }
        return result;
    }

    toggleDay(event: any, day: any) {
        event.preventDefault();
        if (day.mdp.otherMonth && !this.fireEventsForDaysOfSurroundingMonths) {
            return;
        }
        let prevented = false;
        event.preventDefault = () => {
            prevented = true;
        }
        if (typeof this.dayClick == 'function') {
            this.projectScope = [day.date];
            this.generate();
            this.dayClick(event, day);
        }
        if (day.selectable && !prevented) {
            day.mdp.selected = !day.mdp.selected;
            if (day.mdp.selected) {
                this.projectScope.push(day.date);
            } else {
                let idx = -1;
                for (let i = 0; i < this.projectScope.length; ++i) {
                    if (moment.isMoment(this.projectScope[i])) {
                        if (this.projectScope[i].isSame(day.date, 'day')) {
                            idx = i;
                            break;
                        }
                    } else {
                        if (this.projectScope[i].date.isSame(day.date, 'day')) {
                            idx = i;
                            break;
                        }
                    }
                }
                if (idx !== -1) {
                    this.projectScope.splice(idx, 1);
                }
            }
        }
        this.propagateChange(this.projectScope);
    }

    clearDays() {
        this.projectScope = [];
        this.generate();
    }

    runGenerate() {
        this.generate();
    }

    rightClicked(event: any, day: any) {
        if (typeof this.rightClick === 'function') {
            event.preventDefault();
            this.rightClick(event, day);
        }
    }

    getDayClasses(day: any) {
        let css = '';
        if (day.css && (!day.mdp.otherMonth || this.showDaysOfSurroundingMonths)) {
            css += ' ' + day.css;
        }
        if (this.cssDaysOfSurroundingMonths && day.mdp.otherMonth) {
            css += ' ' + this.cssDaysOfSurroundingMonths;
        }
        if (day.mdp.selected) {
            css += ' picker-selected';
        }
        if (day.mdp.cssclass != '') {
            css += ' ' + day.mdp.cssclass;
        }
        if (!day.selectable) {
            css += ' picker-off';
        }
        if (day.istodaydate) {
            css += ' picker-off';
        }
        if (day.mdp.today) {
            if (this.highlightDays !== undefined && this.highlightDays.length > 0) {
                let arrayObject = this.highlightDays.find((highlightDay) => {
                    if (highlightDay.date) {
                        return (moment(highlightDay.date).startOf('day')).isSame(moment(day.date).startOf('day'));
                    }
                    return false;
                });

                if (arrayObject !== undefined) {
                    let highlightDayCss = arrayObject.css;
                    css += ' today ' + highlightDayCss;
                } else {
                    css += ' today ';
                }
            } else {
                css += ' today ';
            }
        }
        if (day.mdp.past) {
            css += ' past';
        }
        if (day.mdp.future) {
            css += ' future';
        }
        if (day.mdp.otherMonth) {
            css += ' picker-other-month';
        }
        return css;
    }

    changeMonth(event: any, disable: any, add: any) {
        if (disable) {
            return;
        }
        event.preventDefault();
        let prevented = false;
        event.preventDefault = () => {
            prevented = true;
        }
        let monthTo = moment(this.month).add(add, 'month');
        if (typeof this.monthClick == 'function') {
            this.monthClick(event, monthTo);
        }
        if (!prevented) {
            let oldMonth = moment(this.month);
            this.month = monthTo;
            if (typeof this.monthChanged == 'function') {
                this.monthChanged(this.month, oldMonth);
            }
            this.generate();
        }
    }

    changeYear(year: any) {
        this.month = this.month.year(parseInt(year, 10));
    }

    isDayOff(day: any) {
        return this.allDaysOff ||
            (this.disableDaysBefore && moment(day.date).isBefore(moment(), 'day')) ||
            (!!this.disableDaysAfter && moment(day.date).isAfter(moment(), 'day')) ||
            ((this.weekDaysOff instanceof Array) && this.weekDaysOff.some(function (dayOff) {
                return day.date.day() === dayOff;
            })) ||
            ((this.daysOff === Array) && this.daysOff.some(function (dayOff: any) {
                return day.date.isSame(dayOff, 'day');
            })) ||
            ((this.daysAllowed === Array) && !this.daysAllowed.some(function (dayAllowed: any) {
                return day.date.isSame(dayAllowed, 'day');
            })) ||
            ((Object.prototype.toString.call(this.highlightDays) === '[object Array]') && this.highlightDays.some(function (highlightDay) {
                return day.date.isSame(highlightDay.date, 'day') && !highlightDay.selectable && highlightDay.css;
            }));
    }

    isSelected(day: any) {
        return this.projectScope && this.projectScope.some(function (d) {
            return day.date.isSame(d, 'day');
        });
    }

    isSelectedDate(day: any) {
        return this.selectedDays.some(function (d) {
            return day.date.isSame(d, 'day');
        });
    }

    generate() {
        let year = this.month.year().toString();
        this.yearsForSelect = this.getYearsForSelect();
        this.monthToDisplay = this.getMonthYearToDisplay();
        this.yearToDisplay = this.month.format('YYYY');
        let previousDay = moment(this.month).date(0).day(this.sundayFirstDay ? 0 : 1).subtract(1, 'day');

        if (moment(this.month).date(0).diff(previousDay, 'day') > 6) {
            previousDay = previousDay.add(1, 'week');
        }
        let firstDayOfMonth = moment(this.month).date(1),
            days = [],
            now = moment(),
            lastDay = moment(firstDayOfMonth).endOf('month'),
            createDate = () => {
                let day = {
                    selectable: true,
                    istodaydate: false,
                    date: moment(previousDay.add(1, 'day')),
                    css: null,
                    title: '',
                    mdp: {
                        selected: false,
                        today: false,
                        past: true,
                        future: true,
                        otherMonth: false,
                        cssclass: ''
                    },
                    slot: {
                        dayCapacity: 0,
                        blackout: 'No',
                        dayAvailable: 0,
                        dayBooked: 0,
                        dailyRate: 0,
                        inventory: false,
                        venues: [],
                        booking: 0
                    }
                }
                if ((Object.prototype.toString.call(this.highlightDays) === '[object Array]')) {
                    var hlDay = this.highlightDays.filter(function (d) {
                        return day.date.isSame(d.date, 'day');
                    });
                    day.css = hlDay.length > 0 ? hlDay[0].css : '';
                    day.title = hlDay.length > 0 ? hlDay[0].title : '';
                    day.slot.dailyRate = hlDay.length > 0 ? hlDay[0].slot.dailyRate : 0;
                    day.slot.dayCapacity = hlDay.length > 0 ? hlDay[0].slot.dayCapacity : 0;
                    day.slot.blackout = hlDay.length > 0 ? hlDay[0].slot.blackout : 'No';
                    day.slot.dayAvailable = hlDay.length > 0 ? hlDay[0].slot.dayAvailable : 0;
                    day.slot.dayBooked = hlDay.length > 0 ? hlDay[0].slot.dayBooked : 0;
                    day.slot.venues = hlDay.length > 0 ? hlDay[0].slot.venues : [];
                    day.slot.inventory = hlDay.length > 0 ? hlDay[0].slot.inventory : false;
                    day.slot.booking = hlDay.length > 0 ? hlDay[0].slot.booking : 0;
                }
                day.selectable = !this.isDayOff(day);
                day.istodaydate = this.disableTodayDate && day.date.isSame(now, 'day');
                day.mdp.selected = this.isSelected(day);
                day.mdp.today = day.date.isSame(now, 'day');
                day.mdp.past = day.date.isBefore(now, 'day');
                day.mdp.future = day.date.isAfter(now, 'day');
                day.mdp.cssclass = '';
                if (!day.date.isSame(this.month, 'month')) {
                    day.mdp.otherMonth = true;
                }
                return day;
            }
        let maxDays = lastDay.diff(previousDay, 'days'),
            lastDayOfWeek = this.sundayFirstDay ? 6 : 0;
        if (lastDay.day() !== lastDayOfWeek) {
            maxDays += (this.sundayFirstDay ? 6 : 7) - lastDay.day();
        }
        for (var j = 0; j < maxDays; j++) {
            days.push(createDate());
        }
        for (var a = 0; a < maxDays; a++) {
            days[a].mdp.selected = this.isSelectedDate(days[a]);
            days[a].mdp.cssclass = this.getRangeClass(days[a]);
            days[a].mdp.cssclass += (days[a].slot.venues.length > 0) ? ' has-events' : '';
        }
        this.days = days;
        this.checkNavigationButtons();
        this.propagateChange(this.projectScope);
    }

    findArrayofDays() {
    }

    getRangeClass(day: any) {
        let x = this.selectedDays.findIndex(function (d) {
            return day.date.isSame(d, 'day');
        });
        return (x == 0 || x == (this.selectedDays.length - 1)) ? '' : 'middle-range';
    }
}
